// :cow: Cosmose CONFIDENTIAL :iso:
import { Component } from '@angular/core';
import { ContainerComponent } from '../shared/modules/container/container/container.component';
import { RouterLink, RouterOutlet } from '@angular/router';
import { LanguageSelectionComponent } from '../shared/modules/layout/components/language-selection/language-selection.component';

@Component({
  selector: 'e-auth',
  templateUrl: 'auth.component.html',
  styleUrls: ['./auth.component.scss'],
  imports: [
    ContainerComponent,
    RouterLink,
    LanguageSelectionComponent,
    RouterOutlet,
  ],
})
export class AuthComponent {
}
